<template>
  <canvas :id="id"></canvas>
</template>
<script>
import Numbers from "numbers";

export default {
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    id: function () {
      return "transformer" + this.index;
    },
  },
  props: {
    width: Number, //宽度
    height: Number, //高度
    struct: Object, //结构文件数据
    index: Number, //多个viewer同时存在于页面时的标识
  },
  methods: {
    print() {
      if (this.struct.format === "SDF" || this.struct.format === "MOL") {
        this.draw_2d_sdf_struct();
        setTimeout(() => {
          this.$emit("closeLoading");
        });
      } else if (this.struct.format === "CIF") {
        this.draw_2d_cif_struct();
        setTimeout(() => {
          this.$emit("closeLoading");
        });
      }
    },
    draw_2d_sdf_struct: function () {
      let viewer = new ChemDoodle.ViewerCanvas(
        this.id,
        this.width,
        this.height,
        true
      );
      viewer.specs.atoms_useJMOLColors = true;
      viewer.specs.atoms_HBlack_2D = false;
      viewer.specs.atoms_circles_2D = true;
      viewer.specs.bonds_clearOverlaps_2D = true;
      viewer.specs.bonds_symmetrical_2D = true;
      viewer.specs.bonds_width_2D = 2;
      viewer.specs.bonds_useJMOLColors = true;
      viewer.specs.set3DRepresentation("Ball and Stick");
      let molecule = ChemDoodle.readMOL(this.struct.data);
      viewer.loadMolecule(molecule);
      return viewer;
    },
    draw_2d_cif_struct: function () {
      let viewer = new ChemDoodle.ViewerCanvas(
        this.id,
        this.width,
        this.height,
        true
      );
      viewer.specs.atoms_useJMOLColors = true;
      viewer.specs.atoms_HBlack_2D = false;
      viewer.specs.atoms_circles_2D = true;
      viewer.specs.atoms_resolution_2D = 1;
      viewer.specs.bonds_clearOverlaps_2D = true;
      viewer.specs.bonds_cylinderDiameter_3D = 0.1;
      viewer.specs.bonds_resolution_3D = 1;
      viewer.specs.bonds_symmetrical_2D = true;
      viewer.specs.crystals_unitCellLineWidth = 1.5;
      viewer.specs.projectionPerspective_3D = false;
      let cell = ChemDoodle.readCIF(this.removeCIFBonds(this.struct.data));
      this.cif_rebond(cell.molecule, cell.unitCell);
      viewer.loadMolecule(cell.molecule);
      return viewer;
    },
    draw_3d_sdf_struct: function (molecule) {
      let viewer = new ChemDoodle.TransformCanvas3D(
        this.id,
        this.width,
        this.height
      );
      viewer.specs.set3DRepresentation("Ball and Stick");
      viewer.specs.lightDirection_3D = [0, 0, -1];
      viewer.specs.bonds_splitColor = true;
      viewer.specs.atoms_useJMOLColors = true;
      viewer.loadMolecule(molecule);
      return viewer;
    },
    draw_3d_cif_struct: function (molecule) {
      let viewer = new ChemDoodle.TransformCanvas3D(
        this.id,
        this.width,
        this.height
      );
      viewer.specs.set3DRepresentation("Ball and Stick");
      viewer.specs.lightDirection_3D = [0, 0, -1];
      viewer.specs.bonds_splitColor = true;
      viewer.specs.atoms_useJMOLColors = true;
      viewer.loadMolecule(molecule);
      return viewer;
    },
    removeCIFBonds: function (str) {
      return str
        .replace(/^loop_\n  _geom.*\n(  .*\n)+/gm, "")
        .replace(/^_shelx_hkl_file.*\n;\n([^;\r\n].*\n)+;\n+/gm, function (m) {
          return "";
        });
    },
    cif_rebond: function (molecule, cell) {
      let delta = 1e-2;
      let shifts = [
        [0, 0, 0],
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1],
        [1, 1, 0],
        [0, 1, 1],
        [1, 0, 1],
        [1, 1, 1],
      ];
      let elementKnowledges = {
        colors: {
          H: [255, 255, 255],
          He: [217, 255, 255],
          Li: [204, 128, 255],
          Be: [194, 255, 0],
          B: [255, 181, 181],
          C: [75, 75, 75],
          N: [48, 80, 248],
          O: [255, 13, 13],
          F: [144, 224, 80],
          Ne: [179, 227, 245],
          Na: [171, 92, 242],
          Mg: [138, 255, 0],
          Al: [191, 166, 166],
          Si: [240, 200, 160],
          P: [255, 128, 0],
          S: [255, 255, 48],
          Cl: [31, 240, 31],
          Ar: [128, 209, 227],
          K: [143, 64, 212],
          Ca: [61, 255, 0],
          Sc: [230, 230, 230],
          Ti: [191, 194, 199],
          V: [166, 166, 171],
          Cr: [138, 153, 199],
          Mn: [156, 122, 199],
          Fe: [224, 102, 51],
          Co: [240, 144, 160],
          Ni: [80, 208, 80],
          Cu: [200, 128, 51],
          Zn: [125, 128, 176],
          Ga: [194, 143, 143],
          Ge: [102, 143, 143],
          As: [189, 128, 227],
          Se: [255, 161, 0],
          Br: [166, 41, 41],
          Kr: [92, 184, 209],
          Rb: [112, 46, 176],
          Sr: [0, 255, 0],
          Y: [148, 255, 255],
          Zr: [148, 224, 224],
          Nb: [115, 194, 201],
          Mo: [84, 181, 181],
          Tc: [59, 158, 158],
          Ru: [36, 143, 143],
          Rh: [10, 125, 140],
          Pd: [0, 105, 133],
          Ag: [192, 192, 192],
          Cd: [255, 217, 143],
          In: [166, 117, 115],
          Sn: [102, 128, 128],
          Sb: [158, 99, 181],
          Te: [212, 122, 0],
          I: [148, 0, 148],
          Xe: [66, 158, 176],
          Cs: [87, 23, 143],
          Ba: [0, 201, 0],
          La: [112, 212, 255],
          Ce: [255, 255, 199],
          Pr: [217, 255, 199],
          Nd: [199, 255, 199],
          Pm: [163, 255, 199],
          Sm: [143, 255, 199],
          Eu: [97, 255, 199],
          Gd: [69, 255, 199],
          Tb: [48, 255, 199],
          Dy: [31, 255, 199],
          Ho: [0, 255, 156],
          Er: [0, 230, 117],
          Tm: [0, 212, 82],
          Yb: [0, 191, 56],
          Lu: [0, 171, 36],
          Hf: [77, 194, 255],
          Ta: [77, 166, 255],
          W: [33, 148, 214],
          Re: [38, 125, 171],
          Os: [38, 102, 150],
          Ir: [23, 84, 135],
          Pt: [208, 208, 224],
          Au: [255, 209, 35],
          Hg: [184, 184, 208],
          Tl: [166, 84, 77],
          Pb: [87, 89, 97],
          Bi: [158, 79, 181],
          Po: [171, 92, 0],
          At: [117, 79, 69],
          Rn: [66, 130, 150],
          Fr: [66, 0, 102],
          Ra: [0, 125, 0],
          Ac: [112, 171, 250],
          Th: [0, 186, 255],
          Pa: [0, 161, 255],
          U: [0, 143, 255],
          Np: [0, 128, 255],
          Pu: [0, 107, 255],
          Am: [84, 92, 242],
          Cm: [120, 92, 227],
          Bk: [138, 79, 227],
          Cf: [161, 54, 212],
          Es: [179, 31, 212],
          Fm: [179, 31, 186],
          Md: [179, 13, 166],
          No: [189, 13, 135],
          Lr: [199, 0, 102],
          Rf: [204, 0, 89],
          Db: [209, 0, 79],
          Sg: [217, 0, 69],
          Bh: [224, 0, 56],
          Hs: [230, 0, 46],
          Mt: [235, 0, 38],
          Ds: [235, 0, 38],
          Rg: [235, 0, 38],
          Cn: [235, 0, 38],
          Uut: [235, 0, 38],
          Uuq: [235, 0, 38],
          Uup: [235, 0, 38],
          Uuh: [235, 0, 38],
          Uus: [235, 0, 38],
          Uuo: [235, 0, 38],
        },
        radii: {
          H: 25,
          He: 31,
          Li: 145,
          Be: 105,
          B: 85,
          C: 70,
          N: 65,
          O: 60,
          F: 50,
          Ne: 38,
          Na: 180,
          Mg: 150,
          Al: 125,
          Si: 110,
          P: 100,
          S: 100,
          Cl: 100,
          Ar: 71,
          K: 220,
          Ca: 180,
          Sc: 160,
          Ti: 140,
          V: 135,
          Cr: 140,
          Mn: 140,
          Fe: 140,
          Co: 135,
          Ni: 135,
          Cu: 135,
          Zn: 135,
          Ga: 130,
          Ge: 125,
          As: 115,
          Se: 115,
          Br: 115,
          Kr: 98,
          Rb: 235,
          Sr: 200,
          Y: 180,
          Zr: 155,
          Nb: 145,
          Mo: 145,
          Tc: 135,
          Ru: 130,
          Rh: 135,
          Pd: 140,
          Ag: 160,
          Cd: 155,
          In: 155,
          Sn: 145,
          Sb: 145,
          Te: 140,
          I: 140,
          Xe: 120,
          Cs: 260,
          Ba: 215,
          La: 195,
          Ce: 185,
          Pr: 185,
          Nd: 185,
          Pm: 185,
          Sm: 185,
          Eu: 185,
          Gd: 180,
          Tb: 175,
          Dy: 175,
          Ho: 175,
          Er: 175,
          Tm: 175,
          Yb: 175,
          Lu: 175,
          Hf: 155,
          Ta: 145,
          W: 135,
          Re: 135,
          Os: 130,
          Ir: 135,
          Pt: 135,
          Au: 135,
          Hg: 150,
          Tl: 190,
          Pb: 180,
          Bi: 160,
          Po: 190,
          At: 185,
          Rn: 160,
          Fr: 220,
          Ra: 215,
          Ac: 195,
          Th: 180,
          Pa: 180,
          U: 175,
          Np: 175,
          Pu: 175,
          Am: 175,
          Cm: 175,
          Bk: 175,
          Cf: 175,
          Es: 175,
          Fm: 175,
          Md: 175,
          No: 175,
          Lr: 175,
          Rf: 175,
          Db: 175,
          Sg: 175,
          Bh: 175,
          Hs: 175,
          Mt: 175,
          Ds: 175,
          Rg: 175,
          Cn: 175,
          Uut: 175,
          Fl: 175,
          Uup: 175,
          Lv: 175,
          Uus: 175,
          Uuo: 175,
        },
      };

      function doNothing() {}

      function DrawColor(color, d) {
        return (ctx, spec) => {
          let obj = Object.create(spec);
          obj.bonds_color = color;
          return d.call(this, ctx, obj);
        };
      }

      function applyswapcoeff(v, s, c) {
        let v1 = [v[0], v[1], v[2]];
        v[0] = c[0] * v1[s[0]];
        v[1] = c[1] * v1[s[1]];
        v[2] = c[2] * v1[s[2]];
      }

      function regularizeCell(atoms, cell, make) {
        let a = [
          cell.x[0] - cell.o[0],
          cell.x[1] - cell.o[1],
          cell.x[2] - cell.o[2],
        ];
        let b = [
          cell.y[0] - cell.o[0],
          cell.y[1] - cell.o[1],
          cell.y[2] - cell.o[2],
        ];
        let c = [
          cell.z[0] - cell.o[0],
          cell.z[1] - cell.o[1],
          cell.z[2] - cell.o[2],
        ];
        let A = Numbers.matrix.transpose([a, b, c]);
        let invA = Numbers.matrix.inverse(Numbers.matrix.deepCopy(A));
        let ans = [];
        // Find out atom with smallest fractional coordinates
        let ab = Numbers.matrix.dotproduct(a, b);
        let bc = Numbers.matrix.dotproduct(b, c);
        let ac = Numbers.matrix.dotproduct(a, c);

        let axisswap = [0, 1, 2];
        let coeff = [1, -1, -1];
        if (
          Math.abs(ab) < delta &&
          Math.abs(bc) < delta &&
          Math.abs(ac) >= delta
        ) {
          // Hexagonal and Monoclinic with beta != 90 degrees
          axisswap = [0, 2, 1];
          coeff = [-1, -1, -1];
        } else if (
          Math.abs(ab) < delta &&
          Math.abs(ac) < delta &&
          Math.abs(bc) >= delta
        ) {
          // Hexagonal and Monoclinic with alpha != 90 degrees
          axisswap = [1, 0, 2];
          coeff = [-1, -1, -1];
        }
        for (let shift of shifts) {
          for (let atom of atoms) {
            let fractional = Numbers.matrix.multiply(invA, [
              [atom.x],
              [atom.y],
              [atom.z],
            ]);
            let u = fractional[0][0],
              v = fractional[1][0],
              w = fractional[2][0];
            (u -= Math.floor(u)), (v -= Math.floor(v)), (w -= Math.floor(w));
            if (u >= 1 - delta) u -= 1;
            if (v >= 1 - delta) v -= 1;
            if (w >= 1 - delta) w -= 1;
            (u += shift[0]), (v += shift[1]), (w += shift[2]);
            if (
              u >= -delta &&
              u <= 1 + delta &&
              v >= -delta &&
              v <= 1 + delta &&
              w >= -delta &&
              w <= 1 + delta
            ) {
              let cartesian = Numbers.matrix.multiply(A, [[u], [v], [w]]);
              let rpos = [
                cell.o[0] + cartesian[0][0],
                cell.o[1] + cartesian[1][0],
                cell.o[2] + cartesian[2][0],
              ];

              ans.push(
                make(
                  coeff[0] * rpos[axisswap[0]],
                  coeff[1] * rpos[axisswap[1]],
                  coeff[2] * rpos[axisswap[2]],
                  atom
                )
              );
            }
          }
        }
        applyswapcoeff(cell.o, axisswap, coeff);
        applyswapcoeff(cell.x, axisswap, coeff);
        applyswapcoeff(cell.y, axisswap, coeff);
        applyswapcoeff(cell.z, axisswap, coeff);
        applyswapcoeff(cell.xy, axisswap, coeff);
        applyswapcoeff(cell.yz, axisswap, coeff);
        applyswapcoeff(cell.xz, axisswap, coeff);
        applyswapcoeff(cell.xyz, axisswap, coeff);
        return ans;
      }

      let scale = 12.5;
      let bonds = [];
      let avgx = 0;
      let avgy = 0;
      let avgz = 0;
      for (let atom of molecule.atoms) {
        avgx += atom.x;
        avgy += atom.y;
        avgz += atom.z;
      }
      avgx /= molecule.atoms.length;
      avgy /= molecule.atoms.length;
      avgz /= molecule.atoms.length;
      for (let atom of molecule.atoms) {
        atom.x -= avgx;
        atom.y -= avgy;
        atom.z -= avgz;
      }

      molecule.atoms = regularizeCell(
        molecule.atoms,
        cell.unitCell,
        (x, y, z, a) =>
          new ChemDoodle.structures.Atom(
            a.label,
            x * scale,
            -y * scale,
            z * scale
          )
      );

      let bondcache = {};

      out: for (let j = 0; j < molecule.atoms.length; j++)
        for (let k = 0; k < j; k++) {
          let a1 = molecule.atoms[j];
          let a2 = molecule.atoms[k];
          let sqdistance =
            (a1.x - a2.x) * (a1.x - a2.x) +
            (a1.y - a2.y) * (a1.y - a2.y) +
            (a1.z - a2.z) * (a1.z - a2.z);
          let radsum =
            elementKnowledges.radii[a1.label] +
            elementKnowledges.radii[a2.label];
          let uplimit =
            1.1 * (scale / 100) * radsum * 1.1 * (scale / 100) * radsum;
          let downlimit =
            0.5 * (scale / 100) * radsum * 0.5 * (scale / 100) * radsum;
          let cachekey =
            Math.round(a1.x * 100) +
            ":" +
            Math.round(a1.y * 100) +
            ":" +
            Math.round(a1.z * 100) +
            "::" +
            Math.round(a2.x * 100) +
            ":" +
            Math.round(a2.y * 100) +
            ":" +
            Math.round(a2.z * 100);
          if (
            !bondcache[cachekey] &&
            sqdistance <= uplimit &&
            sqdistance >= downlimit
          ) {
            bonds.push(new ChemDoodle.structures.Bond(a1, a2, 1));
            if (bonds.length > 1024) break out;
            bondcache[cachekey] = true;
          }
        }

      if (bonds.length > 1024) bonds = [];

      // add the cell boundary, using phantom atoms
      let cellatoms = {};
      let phantoms = Object.keys(cell.unitCell).map((k) => {
        let v = cell.unitCell[k];
        let a = new ChemDoodle.structures.Atom(
          null,
          v[0] * scale,
          -v[1] * scale,
          v[2] * scale
        );
        a.isHidden = true;
        //a.draw = doNothing;
        cellatoms[k] = a;
        return a;
      });
      let aaxis = new ChemDoodle.structures.Bond(cellatoms.o, cellatoms.x);
      let baxis = new ChemDoodle.structures.Bond(cellatoms.o, cellatoms.y);
      let caxis = new ChemDoodle.structures.Bond(cellatoms.o, cellatoms.z);
      //aaxis.draw = DrawColor("red", aaxis.draw);
      //baxis.draw = DrawColor("green", baxis.draw);
      //caxis.draw = DrawColor("blue", caxis.draw);
      bonds.push(
        aaxis,
        baxis,
        caxis,
        new ChemDoodle.structures.Bond(cellatoms.x, cellatoms.xy),
        new ChemDoodle.structures.Bond(cellatoms.y, cellatoms.yz),
        new ChemDoodle.structures.Bond(cellatoms.z, cellatoms.xz),
        new ChemDoodle.structures.Bond(cellatoms.y, cellatoms.xy),
        new ChemDoodle.structures.Bond(cellatoms.z, cellatoms.yz),
        new ChemDoodle.structures.Bond(cellatoms.x, cellatoms.xz),
        new ChemDoodle.structures.Bond(cellatoms.xy, cellatoms.xyz),
        new ChemDoodle.structures.Bond(cellatoms.yz, cellatoms.xyz),
        new ChemDoodle.structures.Bond(cellatoms.xz, cellatoms.xyz)
      );

      molecule.atoms = molecule.atoms.concat(phantoms);
      molecule.bonds = bonds;
    },
  },
  created() {
    this.loading = true;
  },
  mounted() {
    this.print();
  },
  activated() {
    this.print();
  },
  watch: {
    struct: "print",
  },
};
</script>
<style></style>
